'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _variables = require('../../styles/variables');

var styles = {
  badge: {
    position: 'fixed',
    top: '-10px',
    right: '-5px',
    backgroundColor: _variables.colors.red,
    color: _variables.colors.white,
    width: '25px',
    height: '25px',
    textAlign: 'center',
    lineHeight: '25px',
    borderRadius: '50%'
  }
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-popup/lib/components/Badge/style.js
// module id = 1015
// module chunks = 0